import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'

import Header from '../components/Header'
import Footer from '../components/Footer'

import './index.css'

const TemplateWrapper = ({ children }) => (
  <div>
    <Helmet
      title="Tide of Thoughts"
      meta={[
        { name: 'description', content: 'Tide Webs Personal Website' },
        { name: 'keywords', content: 'Tide, Thoughts' },
      ]}
    />
    <link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Open+Sans:300" type="text/css" />
    <link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Seaweed+Script" type="text/css" />
    <link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Mr+De+Haviland" type="text/css" />
    <link rel="logo" href="favicon.ico" type="image/x-icon" />
    <Header />
    <div className="main-wrapper">
      {children()}
    </div>
    {/* <Footer /> */}
  </div>
)

TemplateWrapper.propTypes = {
  children: PropTypes.func,
}

export default TemplateWrapper



// WEBPACK FOOTER //
// ./src/layouts/index.js